import React from 'react';
import { ContactSection as StyledContactSection, SectionHeader, ContactList } from '../styles/supportStyles';
import { ContactItemComponent } from './ContactItem';

/**
 * Componente de seção de contatos (Telefone ou WhatsApp)
 * Renderiza um título com ícone e uma lista de itens de contato
 * 
 * @param {Object} props - Propriedades do componente
 * @param {React.ElementType} props.icon - Componente do ícone a ser exibido no cabeçalho
 * @param {string} props.title - Título da seção (ex: "Telefones", "WhatsApp")
 * @param {string} props.color - Cor do cabeçalho (passada para o styled component)
 * @param {Array} props.items - Lista de contatos { description, number, rawNumber }
 * @param {string} props.type - Tipo da seção ('whatsapp' ou 'phone')
 * @param {string|null} props.copiedNumber - Número atualmente copiado (feedback visual)
 * @param {Function} props.onCopyNumber - Callback para copiar número
 * @param {Function} props.onGetWhatsAppLink - Callback para gerar link do WhatsApp
 */
export const ContactSection = ({
  icon: Icon,          // Renomeia 'icon' para 'Icon' (convenção React para componentes)
  title,               // Título da seção
  color,               // Cor do cabeçalho
  items,               // Array de itens de contato
  type,                // Tipo da seção: 'whatsapp' ou 'phone'
  copiedNumber,        // Número que foi copiado (para mostrar ícone de check)
  onCopyNumber,        // Função para copiar número
  onGetWhatsAppLink    // Função para gerar link do WhatsApp
}) => {
  return (
    < StyledContactSection >
      <SectionHeader color={color}>
        <Icon />     
        <h3>{title}</h3>
      </SectionHeader>
      <ContactList>

        {items.map((item, index) => (
          <ContactItemComponent
            key={`${type}-${index}`}
            item={item}
            type={type}
            copiedNumber={copiedNumber}
            onCopyNumber={onCopyNumber}
            onGetWhatsAppLink={onGetWhatsAppLink}
          />
        ))}
      </ContactList>
    </StyledContactSection >
  );
};